//Servicios
import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

// Obtiene el listado de mensajes de entrada
//CustomerId: Identificador del Cliente
//Destinatary: Filto por destinatario
//Subject: Filto por asunto
//FilterDsc: Descripci�n del Filtro
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListaBandejaEntrada = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/BandejaEntrada/', filtro).then(response => {
            resolve(response);
        });
    });
};

// Obtiene el listado de mensajes de salida
//CustomerId: Identificador del Cliente
//Remitent: Filto por Remitente
//Subject: Filto por asunto
//FilterDsc: Descripci�n del Filtro
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListaBandejaSalida = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/BandejaSalida/', filtro).then(response => {
            resolve(response);
        });
    });
};

// Nuevo mensaje enviado por un cliente
//CustomerSenderId: Identificador del Cliente que env�a mensaje
//Recipients: recipientes receptores dle mensaje
//Subject: Asunto
//MessageBody: Texto del mensaje
//Attachments: Adjuntos
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EnviaNuevoMensaje = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/NuevoMensaje/', registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Responder mensaje enviado por un cliente
//CustomerSenderId: Identificador del Cliente que env�a mensaje
//Recipients: recipientes receptores dle mensaje
//Subject: Asunto
//MessageBody: Texto del mensaje
//Attachments: Adjuntos
//OriginMessageId: Identificador del mensaje original
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EnviaRespuestaMensaje = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/ResponderMensaje/', registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Eliminar mensaje
//CustomerId: Identificador del Cliente
//TypeMessage: Tipo de mensaje
//MessageId: Identificador del mensaje
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EliminaMensaje = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/EliminarMensaje/', registro).then(response => {
            resolve(response)
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Eliminar multiples mensaje
//CustomerId: Identificador del Cliente
//TypeMessage: Tipo de mensaje
//MessageList: Lista de mensajes
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EliminaMultiplesMensaje = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/EliminarVariosMensaje/', registro).then(response => {
            resolve(response)
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Obtiene detalle del mensaje a partir de su identificador
//CustomerId: Identificador del Cliente
//MessageId: Identificador del mensaje
//TypeMessage: Tipo de mensaje
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ObtieneDetalleMensaje = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/ObtenerDetalleMensaje/', registro).then(response => {
            resolve(response)
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Marcar como leido el mensaje a partir de su identificador
//CustomerId: Identificador del Cliente
//MessageId: Identificador del mensaje
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const MarcaComoLeido = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/LecturaMensaje/', registro).then(response => {
            resolve(response)
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Marcar como no leido el mensaje a partir de su identificador
//CustomerId: Identificador del Cliente
//MessageId: Identificador del mensaje
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const MarcaComoNoLeido = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/MarcarNoLeido/', registro).then(response => {
            resolve(response)
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Marcar multiples como no leido el mensaje a partir de su identificador
//CustomerId: Identificador del Cliente
//MessageList: Lista de mensajes
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const MarcaMultiplesComoNoLeido = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/MarcarVariosNoLeidos/', registro).then(response => {
            resolve(response)
        })
            .catch(error => {
                resolve(error.response);
            });
    });
}; 

// Marcar multiples como no leido el mensaje a partir de su identificador
//CustomerId: Identificador del Cliente
//MessageList: Lista de mensajes
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const MarcaMultiplesComoLeido = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/MarcarVariosLeidos/', registro).then(response => {
            resolve(response)
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Obtiene el listado de mensajes de entrada
//CustomerId: Identificador del Cliente
//Portal: A: Administrative Portal, E: Student Portal, P: Instructor Portal
//DscFilter: Filtro por nombre
//ReceiverType: A: Administrative, E: Student, P: Instructor, if empty: All
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListaDestinatarios = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/ListaDestinatarios/', filtro).then(response => {
            resolve(response);
        });
    });
};

// Obtiene el listado de destinatarios de un mensaje
//MessageId: Identificador del mensaje
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListaDestinatariosXMensajes = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/DestinatariosXMensaje/', filtro).then(response => {
            resolve(response);
        });
    });
};

// Obtiene el listado de adjuntos de un mensaje
//MessageId: Identificador del mensaje
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListaAdjuntosXMensajes = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/AdjuntosXMensaje/', filtro).then(response => {
            resolve(response);
        });
    });
};


// Obtiene el listado de adjuntos de un mensaje
//MessageId: Identificador del mensaje
//AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const NuevasNotificacionesUsuario = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/MensajeriaInterna/MensajesSinLeerUsuario/', filtro).then(response => {
            resolve(response);
        });
    });
};

export default ListaBandejaEntrada;